// The refused products' shipping rates (owner, 2026-11-02 — point 2): products the partner refuses
// (cosmetics, liquids, cameras …) go by sea and air with the cheaper of HioBuy and DHL Global
// Forwarding — door to door, shipping and customs included, SAR — per class. No row (or a disabled
// one) means that option shows «اطلب سعر الشحن» for those products. Never shown to traders: the
// cart sees the numbers without the carrier (market_public_state().delivered.refused_rates).
// Writes go through admin_market_carrier_rate_set (audited); the table is admin-readable only.
import { marketDb, marketRpc } from './marketDb';

export const CARRIERS = ['hiobuy', 'dhl_gf'];
export const MODES = ['air', 'sea'];
export const CLASSES = ['general', 'electrical', 'sensitive'];

export async function listCarrierRates() {
  const { data, error } = await marketDb.from('market_carrier_rates').select('*');
  return error ? { ok: false, error: error.message } : { ok: true, data: data || [] };
}

/** A positive number, or null for empty; NaN when it is not a number. */
export function parseRate(v) {
  const t = String(v ?? '').trim().replace(',', '.');
  if (!t) return null;
  const n = Number(t);
  return Number.isFinite(n) && n >= 0 ? n : NaN;
}

/** A row is valid when it has a rate > 0, a minimum ≥ 0 and days with min ≤ max. Returns an error key or null. */
export function rowError(r) {
  const rate = parseRate(r.rate), min = parseRate(r.min), a = parseRate(r.days_min), b = parseRate(r.days_max);
  if (rate == null) return null;                       // empty: a delete
  if (Number.isNaN(rate) || !(rate > 0)) return 'rate';
  if (Number.isNaN(min)) return 'min';
  if (a == null || b == null || Number.isNaN(a) || Number.isNaN(b) || !Number.isInteger(a) || !Number.isInteger(b) || a < 1 || b < a) return 'days';
  return null;
}

/** Save one row; an empty rate deletes it (that option goes back to «اطلب سعر الشحن»). */
export const setCarrierRate = (carrier, mode, cls, r) => marketRpc('admin_market_carrier_rate_set', {
  p_carrier: carrier, p_mode: mode, p_class: cls, p_rate: parseRate(r.rate), p_min: parseRate(r.min) ?? 0,
  p_days_min: parseRate(r.days_min), p_days_max: parseRate(r.days_max), p_enabled: r.enabled !== false, p_note: r.note || null,
});
